import { CallOffOrderColor, QuotedColor } from '@ravago/shared/page-data/models/elements';

import { ReadonlyURLSearchParams } from 'next/navigation';

import { parseProductActionIntent } from './product-action-url-state';

export const getDefaultExpanded = (hasCustomerColors: boolean, searchParams?: ReadonlyURLSearchParams): 'rfq' | 'order-now' => {
   if (searchParams?.get('open-rfq-after-login') === 'true' || (searchParams && parseProductActionIntent(searchParams).type === 'rfq')) {
      return 'rfq';
   }

   if (hasCustomerColors) {
      return 'order-now';
   }
   return 'rfq';
};

export const getDefaultSelectedOrderNow = (searchParams: URLSearchParams, callOffOrderColors: CallOffOrderColor[], quotedColors: QuotedColor[]) => {
   const from = searchParams.get('from');

   // New schema (My products & prices V1/V2 cards): ?from=quote|call-off&colorId=X[&colorCode=Y]
   const rawColorId = searchParams.get('colorId');
   if (rawColorId) {
      const colorId = Number(rawColorId);
      const colorCode = searchParams.get('colorCode') ?? undefined;
      if (from === 'quote') {
         return (
            quotedColors.find((q) => q.color.id === colorId && q.color.producerColorCode === colorCode) ??
            quotedColors.find((q) => q.color.id === colorId)
         );
      }
      if (from === 'call-off') {
         return (
            callOffOrderColors.find((c) => c.color.id === colorId && c.color.producerColorCode === colorCode) ??
            callOffOrderColors.find((c) => c.color.id === colorId)
         );
      }
   }

   // Legacy schema (call-off order detail links): ?from=quote|call-off&color=NAME[&producerColorCode=CODE]
   const colorName = searchParams.get('color') ?? undefined;
   const producerColorCode = searchParams.get('producerColorCode') ?? undefined;
   if (from === 'quote' && colorName) {
      return (
         quotedColors.find((q) => q.color.name.toLowerCase() === colorName.toLowerCase() && q.color.producerColorCode === producerColorCode) ??
         quotedColors.find((q) => q.color.name.toLowerCase() === colorName.toLowerCase())
      );
   }
   if (from === 'call-off' && colorName) {
      return (
         callOffOrderColors.find((c) => c.color.name.toLowerCase() === colorName.toLowerCase() && c.color.producerColorCode === producerColorCode) ??
         callOffOrderColors.find((c) => c.color.name.toLowerCase() === colorName.toLowerCase())
      );
   }

   return callOffOrderColors[0] ?? quotedColors[0];
};
